import { FC, RefObject, useMemo } from 'react';
import { typeMeeting } from '@monorepo/models';
import { useExcelMaker, usePdfMaker } from 'src/custom-hooks';

type propsType = {
    meetings: typeMeeting[];
    month: string;
    tableRef: RefObject<HTMLTableElement | null>;
};

export const MeetingAttendanceTablePrint: FC<propsType> = ({ meetings, month, tableRef }) => {
    const excelMaker = useExcelMaker();
    const headers = ['Fecha', 'Presencial', 'Zoom', 'YouTube', 'Total', 'Notas'];
    const pdfMaker = usePdfMaker();

    const data: (string | number)[][] = useMemo(() => {
        const order = ['inPerson', 'zoom', 'youtube', 'total', 'notes'];
        const data = meetings.map(m => [m.date, ...order.map(key => (m.attendance as any)[key])]);
        return data;
    }, [meetings]);

    const saveToExcel = () => {
        const styles = {
            widths: [
                { i: 0, width: 15 },
                { i: 5, width: 80 }
            ]
        };
        const fileName = `Asistencia_${month}.xlsx`;
        excelMaker(headers, data, styles, fileName);
    }

    const saveToPdf = () => {
        if (!tableRef.current) {
            return;
        }
        const fileName = `Asistencia_${month}.pdf`;
        tableRef.current.classList.add('hide-column-pdf');
        pdfMaker(tableRef.current, fileName);
        tableRef.current.classList.remove('hide-column-pdf');
    }

    return (
        <div className={'mb-4 text-center'}>
            <button className={'btn btn-general-blue px-4 me-1'}
                onClick={saveToExcel}
            >
                Imprimir en Excel
            </button>
            <button className={'btn btn-general-blue px-4 ms-1'}
                onClick={saveToPdf}
            >
                Imprimir en PDF
            </button>
        </div>
    );
}
